var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 5.41667C3.125 4.15102 4.15102 3.125 5.41667 3.125H11.8056C12.7644 3.125 13.5417 3.90228 13.5417 4.86111V7.29167M3.125 5.41667C3.125 6.4522 3.96447 7.29167 5 7.29167H13.5417M3.125 5.41667V9.375M13.5417 7.29167H14.375C15.7557 7.29167 16.875 8.41092 16.875 9.79167V14.375C16.875 15.7557 15.7557 16.875 14.375 16.875H10.2083",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99999 11.2148L7.70832 12.7947V15.9544L4.99999 17.5343L2.29166 15.9544V12.7947L4.99999 11.2148Z",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 12.0833V12.075M13.125 12.0833C13.125 12.1984 13.0318 12.2917 12.9167 12.2917C12.8016 12.2917 12.7083 12.1984 12.7083 12.0833C12.7083 11.9682 12.8016 11.875 12.9167 11.875C13.0318 11.875 13.125 11.9682 13.125 12.0833Z",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingTransaction);
export default __webpack_public_path__ + "static/media/billing_transaction.c20f0ae46879d96a060bf4d3378f9859.svg";
export { ForwardRef as ReactComponent };